/**
 * @packageDocumentation
 * @module dom/element
 */

export interface ParentsOf {
  /**
   *
   * @param el the element to search the parent dom tree
   * @return get a list of all parent elements
   */
  (el: Element | Node): (Element | Node)[];
}

/**
 * { @link ParentsOf }
 */
export default (el: Element | Node): (Element | Node)[] => {
  let parentEl: Element | Node | null = el;
  const list = [];

  while (parentEl != null) {
    list.push(parentEl);

    if (parentEl.parentNode != null) {
      parentEl = parentEl.parentNode;
    } else if (parentEl.getRootNode()['host'] != null) {
      parentEl = parentEl.getRootNode()['host'];
    } else {
      parentEl = null;
    }
  }

  return list;
};
